import { Box, Skeleton, Stack, Modal, CircularProgress } from '@mui/material';

const CertificateInformationSkeleton = (props: any) => {
  const { isLoading, isLoadingEvent, children } = props;

  // REGION: LOADING EVENT STYLE
  const loadingEventStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };

  return (
    <Box sx={{ position: 'relative' }}>
        {
        isLoadingEvent && <Modal open={true}>
            <Box sx={loadingEventStyle}>
                <CircularProgress />
            </Box>
        </Modal>
        }
        {
        isLoading && <Box sx={{ position: 'absolute', width:'100%', zIndex: 2, backgroundColor: '#FFFFFF' }}>
            <Box height={'24px'}/>
            <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} animation="wave" width="350px" height={40}/>
            <Box height={'34px'}/>
            <Stack direction="row" spacing={2} width="100%">
                <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} width="145px" height={40} />
                <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} width="140px" height={40} />
                <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} width="105px" height={40} />
                <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} width="300px" height={40} />
                <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} width="75px" height={40} />
            </Stack>
            <Box height={'33px'}/>
            <Skeleton variant="rectangular" sx={{ borderRadius: '10px' }} animation="wave" width={'100%'} height={800}/>
        </Box>
        }
        <Box sx={{ position: 'absolute', width:'100%', zIndex: 1,  }}> {children} </Box>
    </Box>
    );
};

export default CertificateInformationSkeleton;
